import { render } from "./BuyTravelComponent.vue?vue&type=template&id=e1f5f044&ts=true"
import script from "./BuyTravelComponent?vue&type=script&lang=ts"
export * from "./BuyTravelComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__